import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29861945"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "footer__top" }
const _hoisted_4 = { class: "footer__logo svg-path-white" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("address", null, [
  /*#__PURE__*/_createTextVNode(" Engenious sp. z o.o."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 31-123 Kraków, Poland"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Krupnicza 3 ")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode(" NIP: 6772396254"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" REGON: 363242905"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" KRS: 0000592144 ")
], -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("address", null, [
    /*#__PURE__*/_createTextVNode(" Engenious AG"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Baarerstrasse 10, 6300 Zug"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" ZG, Switzerland ")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, "CHE-468.218.726")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "footer__title" }, "Services", -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Cloud Solutions")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Artificial Intelligence ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Cybersecurity")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Architecture")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Data & Analytics")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("QA & Testing")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Software Development")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("DevOps")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Documentation")
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "footer__title" }, "Company", -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Services")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Success Stories")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Careers")
const _hoisted_24 = { key: 0 }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Team")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Contact")
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "footer__title footer__title--contact" }, "Contact", -1))
const _hoisted_28 = { key: 0 }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "mailto:hello@engenious.ch" }, [
  /*#__PURE__*/_createElementVNode("u", null, "hello@engenious.ch")
], -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = { key: 1 }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "mailto:hello@engenious.pl" }, [
  /*#__PURE__*/_createElementVNode("u", null, "hello@engenious.pl")
], -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = {
  href: "https://www.linkedin.com/company/engenious/",
  target: "_blank"
}
const _hoisted_35 = { class: "footer__bottom" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("Privacy Policy")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_logo = _resolveComponent("icon-logo")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_icon_linkedin = _resolveComponent("icon-linkedin")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [
                _createVNode(_component_icon_logo)
              ]),
              _: 1
            })
          ]),
          (!_ctx.isChApp)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
            : _createCommentVNode("", true),
          _hoisted_9
        ]),
        _createElementVNode("div", null, [
          _hoisted_10,
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/our-services" }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/our-services" }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/our-services" }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/our-services" }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/our-services" }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/our-services" }, {
                default: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/our-services" }, {
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/our-services" }, {
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/our-services" }, {
                default: _withCtx(() => [
                  _hoisted_19
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_20,
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/our-services" }, {
                default: _withCtx(() => [
                  _hoisted_21
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/success-stories" }, {
                default: _withCtx(() => [
                  _hoisted_22
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/join-us" }, {
                default: _withCtx(() => [
                  _hoisted_23
                ]),
                _: 1
              })
            ]),
            (!_ctx.isChApp)
              ? (_openBlock(), _createElementBlock("li", _hoisted_24, [
                  _createVNode(_component_router_link, { to: "/our-team" }, {
                    default: _withCtx(() => [
                      _hoisted_25
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/contact-us" }, {
                default: _withCtx(() => [
                  _hoisted_26
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_27,
          _createElementVNode("ul", null, [
            (_ctx.isChApp)
              ? (_openBlock(), _createElementBlock("li", _hoisted_28, _hoisted_30))
              : _createCommentVNode("", true),
            (!_ctx.isChApp)
              ? (_openBlock(), _createElementBlock("li", _hoisted_31, _hoisted_33))
              : _createCommentVNode("", true),
            _createElementVNode("li", null, [
              _createElementVNode("a", _hoisted_34, [
                _createVNode(_component_icon_linkedin)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", null, " Copyright © " + _toDisplayString(_ctx.currentYear) + " Engenious. All rights reserved. ", 1),
        _createVNode(_component_router_link, { to: "/page/privacy-policy" }, {
          default: _withCtx(() => [
            _hoisted_36
          ]),
          _: 1
        })
      ])
    ])
  ]))
}